import React from 'react';

import cn from 'classnames';

import { ArrowUpSVG, StopSVG } from '@components/svgs';

interface SendButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  isLoading?: boolean;
}

export const SendButton: React.FC<SendButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  isLoading = false,
  ...props
}) => (
  <button
    {...props}
    onClick={onClick}
    disabled={!isLoading && disabled}
    aria-label={isLoading ? 'Stop generation' : 'Send message'}
    className={cn(
      'flex h-6 w-6 items-center justify-center rounded-full',
      {
        'border border-gray-300 bg-gray-100 text-gray-300': !isLoading && disabled,
        'bg-indigo-600 text-white hover:bg-indigo-700': !disabled
      },
      className
    )}
  >
    {isLoading ? <StopSVG className='h-4 w-4' /> : <ArrowUpSVG className='h-4 w-4' />}
  </button>
);
